import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyDhOHEthXMVxLFgOW7o38BCjv3YEA0Pq8Q",
  authDomain: "dailygoals-1292e.firebaseapp.com",
  projectId: "dailygoals-1292e",
  storageBucket: "dailygoals-1292e.appspot.com",
  messagingSenderId: "974246602814",
  appId: "1:974246602814:web:050cdb7b948080433bc96f",
  measurementId: "G-G673QEFZHF",
};

export const Firebase = initializeApp(firebaseConfig);
export const auth = getAuth();
export const Providers = { google: new GoogleAuthProvider() };
export const db = getFirestore(Firebase);
